
import Vue from "vue"
import SingleBayCell from "./SingleBayView/SingleBayCell.vue"
import { mapGetters, mapActions } from "vuex"

export default Vue.extend({
  components: {
    SingleBayCell
  },
  data() {
    return {
      dialog: true,
      containerImage: 'https://cdn-tex.baplieviewer.com/thumbs/BVO-general40.jpg?ver=1611000803175',
      containerData: {
        'Position': '0060888',
        'ISO Code': '45G0',
        'Line Operator': 'BVO',
        'Container Type': '45G0',
        'Container Size': '45',
        'Container Height': '9.6',
        'Container Status': 'F',
        'Container Status Description': 'Full',
        'Container Status Date': '2021-01-19 00:00:00',
        'Container Status Location': 'BEANR',
        'Container Status Location Description': 'ANTWERP',
        'Container Status Location Country': 'BE',
        'Container Status Location Country Description': 'BELGIUM',
        'Container Status Location UN/LOCODE': 'BEANR',
        'Container Status Location UN/LOCODE Description': 'ANTWERP',
        'ISO Code Description': 'Container Type',
        'Container Type Description': 'Container Type',
        'Container Size Description': 'Container Size',
      }
    }
  },
  computed: {
    ...mapGetters(['getIsVesselMonitoringContainerDetailModalOpen', 'getVesselMonitoringContainerDetailResponse']),
    VesselMonitoringContainerDetailResponse: {
      get() {
        return this.getVesselMonitoringContainerDetailResponse
      }
    },
    IsVesselMonitoringContainerDetailModalOpen: {
      get() {
        return this.getIsVesselMonitoringContainerDetailModalOpen
      },
      set(value) {
        this.setIsVesselMonitoringContainerDetailModalOpen(value)
      }
    },
  },
  mounted() {
    // Close modal with 'esc' key
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.IsVesselMonitoringContainerDetailModalOpen = false
      }
    })
  },

  methods: {
    ...mapActions(['setIsVesselMonitoringContainerDetailModalOpen'])
  },

})
